<template lang="pug">
  .upload-photo-2
    .upload-photo-2__notification Размер фото не больше 7мб
    .upload-photo-2__main
      ul.upload-photo-2__list
        li.upload-photo-2__item(
        v-for="(photo, index) in localPhotos"
        )
          .upload-photo-2__img-container
            img.upload-photo-2__img(
            :src="getFilePath(photo)"
            )
            button.upload-photo-2__img-delete(
            @click.prevent="onDeleteButton(index)"
            )
              img(src="@/assets/images/icons/close-button.svg")
            .upload-photo-2__img-overlay
        li.upload-photo-2__item
          .upload-photo-2__button
            .button
              .button__icon
                img(src="@/assets/images/icons/clip.svg")
              .button__text Добавить файл
              .input-file
                label.input-file__label
                  input.input-file__input(
                  type="file"
                  @change="onAddPhoto($event)"
                  )
                  .input-file__outline
</template>
<script>
import {mapActions} from "vuex";

export default {
  name: "UploadPhoto2",
  props: {
    photos: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    localPhotos: {
      get() {
        return this.photos;
      },
      set(val) {}
    }
  },
  methods: {
    ...mapActions(["addAttachments"]),
    onAddPhoto(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      const type = "1"; //image: "1"
      if (!file || !type) {
        return;
      }
      formData.append("file", file);
      formData.append("attachment_type", type);
      this.addAttachments(formData).then(response => {
        if (response.status === 201) {
          this.localPhotos.push(response.data);
          this.$emit("on-change", this.localPhotos);
        } else {
          alert(response.status);
        }
      });
    },
    onDeleteButton(index) {
      this.localPhotos.splice(index, 1);
      this.$emit("on-change", this.localPhotos);
    },
    getFilePath(photo) {
      if (photo.preview_376x340) {
        return photo.preview_376x340;
      }
      return photo.file;
    }
  }
};
</script>
